export const environment = {
  production: true,
  buildId: '4184386749524961',
  configFile: 'config.json',
};
